'use es6';

import { createSelector } from 'reselect';
import { List } from 'immutable';
import { getLesson } from './lessonSelectors';
import { getTrack } from './trackSelectors';
export const getRecommendationsMap = state => state.recommendations;
export const getRecommendationsSelector = createSelector(getRecommendationsMap, map => map.get('data') || List());
export const getRecommendationsIsRequesting = createSelector(getRecommendationsMap, map => map.get('isRequesting'));
export const getRecommendationsHasError = createSelector(getRecommendationsMap, map => map.get('hasError'));
export const getRecommendationsRecentError = createSelector(getRecommendationsMap, map => map.get('recentError'));
export const getRecommendationsMetadataList = (state, recommendations) => recommendations.map(recommendation => {
  const metadata = recommendation.recommendationMetadata;

  if (metadata.entityType === 'LESSON') {
    const lesson = getLesson(state, {
      lessonId: metadata.entityId
    });
    return Object.assign({}, metadata, {
      entityCategory: 'CONTENT',
      contentName: lesson && lesson.get('name'),
      href: `/academy/${state.auth.portal.portal_id}/lessons/${metadata.entityId}`
    });
  }

  if (metadata.entityType === 'TRACK') {
    const track = getTrack(state, {
      trackId: metadata.entityId
    });
    return Object.assign({}, metadata, {
      entityCategory: 'CONTENT',
      contentName: track && track.get('name'),
      href: `/academy/${state.auth.portal.portal_id}/tracks/${metadata.entityId}`
    });
  }

  return metadata;
});
export const getRecommendationsTopicPreferencesMap = createSelector(getRecommendationsMap, map => map.get('topicPreferences'));
export const getRecommendationsTopicPreference = createSelector(getRecommendationsTopicPreferencesMap, map => map.get('data'));
export const getRecommendationsTopicPreferenceIsRequesting = createSelector(getRecommendationsTopicPreferencesMap, map => map.get('isRequesting'));